export const STATUS_TYPE = {
  0: { text: '未执行', color: 'info' },
  1: { text: '执行中', color: 'warning' },
  2: { text: '已经完成', color: 'success' }
};

export const TEMPLATE_URL =
  'https://alpha-dev-pub-hz.oss-cn-hangzhou.aliyuncs.com/mining/mining20180921112128117.xlsx';
